import React from 'react';

import classes from './Tags.module.scss';

const Tags = ({ text, type }) => {
  return (
    <div className={`${classes.status} ${classes[type]}`}>
      <span className='semibold-16'>{text}</span>
    </div>
  );
};

export default Tags;
